var _defs, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
var SvgAzure = function SvgAzure(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 96 96",
    ref: ref
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "azure_svg__a",
    x1: -1032.172,
    x2: -1059.213,
    y1: 145.312,
    y2: 65.426,
    gradientTransform: "matrix(1 0 0 -1 1075 158)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#114a8b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0669bc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "azure_svg__b",
    x1: -1023.725,
    x2: -1029.98,
    y1: 108.083,
    y2: 105.968,
    gradientTransform: "matrix(1 0 0 -1 1075 158)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.071,
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.321,
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.623,
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "azure_svg__c",
    x1: -1027.165,
    x2: -997.482,
    y1: 147.642,
    y2: 68.561,
    gradientTransform: "matrix(1 0 0 -1 1075 158)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3ccbf4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2892df"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#azure_svg__a)",
    d: "M33.338 6.544h26.038l-27.03 80.087a4.15 4.15 0 0 1-3.933 2.824H8.149a4.145 4.145 0 0 1-3.928-5.47L29.404 9.368a4.15 4.15 0 0 1 3.934-2.825z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#0078d4",
    d: "M71.175 60.261h-41.29a1.911 1.911 0 0 0-1.305 3.309l26.532 24.764a4.17 4.17 0 0 0 2.846 1.121h23.38z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#azure_svg__b)",
    d: "M33.338 6.544a4.12 4.12 0 0 0-3.943 2.879L4.252 83.917a4.14 4.14 0 0 0 3.908 5.538h20.787a4.44 4.44 0 0 0 3.41-2.9l5.014-14.777 17.91 16.705a4.24 4.24 0 0 0 2.666.972H81.24L71.024 60.261l-29.781.007L59.47 6.544z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#azure_svg__c)",
    d: "M66.595 9.364a4.145 4.145 0 0 0-3.928-2.82H33.648a4.15 4.15 0 0 1 3.928 2.82l25.184 74.62a4.146 4.146 0 0 1-3.928 5.472h29.02a4.146 4.146 0 0 0 3.927-5.472z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgAzure);
var Memo = /*#__PURE__*/memo(ForwardRef);
export default Memo;